/**
 * Colors
 *
 * Color Names can be chosen here
 * http://chir.ag/projects/name-that-color
 */

export type Color = {
  25?: string;
  50?: string;
  100?: string;
  200?: string;
  300?: string;
  400?: string;
  500?: string;
  600?: string;
  700?: string;
  800?: string;
  900?: string;
}

export interface Colors {
  plum: Color;
  berry: Color;
  grass: Color;
  turquoise: Color;
  tomato: Color;
  orange: Color;
  lemon: Color;
  sky: Color;
  coolgray: Color;
  neutralgray: Color;
  white: Color;
  black: Color;
}

export const plum = {
  25: '#FAF7FC',
  50: '#F1ECF9',
  100: '#E4D9F2',
  200: '#C9B3E5',
  300: '#AD8CD9',
  400: '#9266CC',
  500: '#7740BF',
  600: '#5F3399',
  700: '#472673',
  800: '#30194D',
  900: '#180D26',
};

export const berry = {
  25: '#FDF7FB',
  50: '#FBEAF6',
  100: '#F6D5ED',
  200: '#EDABDA',
  300: '#E481C8',
  400: '#DB57B6',
  500: '#D22DA3',
  600: '#A82483',
  700: '#7E1B62',
  800: '#541241',
  900: '#2A0921',
};

export const grass = {
  25: '#F8FCF9',
  50: '#EDF7EF',
  100: '#DBF0DF',
  200: '#B8E0BE',
  300: '#94D19E',
  400: '#70C27E',
  500: '#4DB35E',
  600: '#3D8F4B',
  700: '#2E6B38',
  800: '#1F4725',
  900: '#0F2413',
};

export const turquoise = {
  25: '#F8FCFC',
  50: '#EDF7F7',
  100: '#DBEFF0',
  200: '#B8DEE0',
  300: '#94CED1',
  400: '#70BEC2',
  500: '#4DAEB3',
  600: '#3D8B8F',
  700: '#2E686B',
  800: '#1E4547',
  900: '#0F2324',
};

export const tomato = {
  25: '#FDF7F7',
  50: '#FBEAEA',
  100: '#F6D5D5',
  200: '#EDABAB',
  300: '#E48181',
  400: '#DB5757',
  500: '#D22D2D',
  600: '#A82424',
  700: '#7E1B1B',
  800: '#541212',
  900: '#2A0909',
};

export const orange = {
  25: '#FEF9F6',
  50: '#FDEFE7',
  100: '#FBE0D0',
  200: '#F8C0A0',
  300: '#F4A171',
  400: '#F18241',
  500: '#ED6212',
  600: '#BE4F0E',
  700: '#8E3B0B',
  800: '#5F2707',
  900: '#2F1404',
};

export const lemon = {
  25: '#FEFCF6',
  50: '#FCF7E8',
  100: '#FAEED1',
  200: '#F5DEA3',
  300: '#F0CD75',
  400: '#EBBC47',
  500: '#E6AC19',
  600: '#B88914',
  700: '#8A670F',
  800: '#5C450A',
  900: '#2E2205',
};

export const sky = {
  25: '#F7FAFD',
  50: '#EBF3FA',
  100: '#D6E6F5',
  200: '#ADCDEB',
  300: '#85B4E0',
  400: '#5C9BD6',
  500: '#3382CC',
  600: '#2968A3',
  700: '#1F4E7A',
  800: '#143452',
  900: '#0A1A29',
};

export const coolgray = {
  25: '#F9FAFA',
  50: '#F1F1F4',
  100: '#E3E4E8',
  200: '#C6C8D2',
  300: '#AAADBB',
  400: '#8E92A4',
  500: '#71768E',
  600: '#5B5F71',
  700: '#444755',
  800: '#2A274B',
  900: '#14113B',
};

export const neutralgray = {
  25: '#FAFAFA',
  50: '#F2F2F2',
  100: '#E6E6E6',
  200: '#CCCCCC',
  300: '#B3B3B3',
  400: '#999999',
  500: '#808080',
  600: '#666666',
  700: '#4D4D4D',
  800: '#333333',
  900: '#1A1A1A',
};

export const white = {
  500: '#FFFFFF',
};

export const black = {
  500: '#000000',
};
